import { render, staticRenderFns } from "./ContractButton.vue?vue&type=template&id=6c7e34f8&lang=pug&"
import script from "./ContractButton.vue?vue&type=script&lang=js&"
export * from "./ContractButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports